import { render, staticRenderFns } from "./addCalcSalary.vue?vue&type=template&id=afed90ba&scoped=true&"
import script from "./addCalcSalary.vue?vue&type=script&lang=js&"
export * from "./addCalcSalary.vue?vue&type=script&lang=js&"
import style0 from "./addCalcSalary.vue?vue&type=style&index=0&id=afed90ba&prod&lang=scss&scoped=true&"
import style1 from "./addCalcSalary.vue?vue&type=style&index=1&id=afed90ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afed90ba",
  null
  
)

export default component.exports